import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchWellTestDataForCharts } from '../../services/dashboard/AssetTrendDataService';

interface WellTestChartDataState {
  data: any[];
  installations: any[];
  currentInstall: any;
  popDate: any;
  loading: boolean;
  error?: any;
  dateRange: { startDate: Date; endDate: Date } | null;
}

const initialState: WellTestChartDataState = {
  data: [],
  installations: [],
  currentInstall: null,
  popDate: null,
  loading: false,
  error: undefined,
  dateRange: null,
};

const WellTestChartDataSlice = createSlice({
  name: 'WellTestChartDataSlice',
  initialState,
  reducers: {
    setInitialState: (state) => {
      state.data = [];
      state.installations = [];
      state.currentInstall = null;
      state.popDate = null;
      state.error = undefined;
      state.loading = false;
      state.dateRange = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchInitialWellChartDataAsync.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchInitialWellChartDataAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.WellTests;
        state.installations = action.payload.Installations;
        state.currentInstall = action.payload.CurrentInstall;
        state.popDate = action.payload.PopDate;
        state.dateRange = {
          startDate: action.payload.startDate,
          endDate: action.payload.endDate,
        };
      })

      .addCase(fetchInitialWellChartDataAsync.rejected, (state) => {
        state.loading = false;
      });
  },
});

// Async thunk to fetch the initial state data
export const fetchInitialWellChartDataAsync = createAsyncThunk(
  'WellTestChartDataSlice/fetchInitialState',
  async ({ wellId, startDate, endDate }: { wellId: string; startDate: Date; endDate: Date }) => {
    const response = await fetchWellTestDataForCharts(wellId, startDate, endDate);
    return response;
  },
);

export const { setInitialState } = WellTestChartDataSlice.actions;

export default WellTestChartDataSlice.reducer;
